// extracted by mini-css-extract-plugin
export var currencyInput = "_o1-1";
export var currencySymbol = "_o1-0";